import React, { useEffect, useCallback, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import AppContext from "../context/AppContext";
import MetaData from "../helpers/MetaData";
import GoToTop from "../helpers/GoToTop";
import ApiService from "../api/ApiService";
import notification from "../helpers/notification";
import moment from "moment";
import { Modal } from "react-bootstrap";
import DownloadTenbe from "../components/10BE/downloadTenbe";

const AnnadaanSevaDashboard = () => {
  const { donor } = useContext(AppContext);
  const navigate = useNavigate();
  const [bookingsData, setBookingsDataFromBackend] = useState([]);
  const [bookingid, setBookingid] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [cancelComment, setCancelComment] = useState("");
  const [inspiration, setInspiration] = useState([]);
  const [clarity, setClarity] = useState("");
  const [challenges, setChallenges] = useState("");
  const [challengeDetails, setChallengeDetails] = useState("");
  const [suggestions, setSuggestions] = useState("");

  const closeDialogView = () => {
    setIsDialogOpen(false);
    setCancelComment("");
  };

  const closeFeedbackView = () => {
    setIsFeedbackOpen(false);
    setFeedbackText("");
  };

  const fetchBookings = useCallback(async () => {
    try {
      const id = donor?.phone;
      const response = await ApiService.getAllAnnadaanSevaBookingsdb(id);
      const updatedData = {};

      // Auto-close logic
      for (const [date, entries] of Object.entries(response.data)) {
        updatedData[date] = entries.map((entry) => {
          const entryDate = moment(date, "YYYY-MM-DD");
          if (moment().isAfter(entryDate) && entry.status === "active") {
            return { ...entry, status: "closed" };
          }
          return entry;
        });
      }

      // Sort the data by date in descending order (newest first)
      const sortedData = {};
      const sortedDates = Object.keys(updatedData).sort((a, b) => {
        return moment(b, "YYYY-MM-DD").valueOf() - moment(a, "YYYY-MM-DD").valueOf();
      });

      sortedDates.forEach(date => {
        sortedData[date] = updatedData[date];
      });

      setBookingsDataFromBackend(sortedData);
    } catch (error) {
      console.log("error", error);
    }
  }, [donor?.phone]);
  // const fetchBookings = useCallback(async () => {
  //   try {
  //     const id = donor?.phone;
  //     const response = await ApiService.getAllAnnadaanSevaBookingsdb(id);
  //     const updatedData = {};

  //     // Auto-close logic
  //     for (const [date, entries] of Object.entries(response.data)) {
  //       updatedData[date] = entries.map((entry) => {
  //         const entryDate = moment(date, "YYYY-MM-DD");
  //         if (moment().isAfter(entryDate) && entry.status === "active") {
  //           return { ...entry, status: "closed" };
  //         }
  //         return entry;
  //       });
  //     }
  //     setBookingsDataFromBackend(updatedData);
  //   } catch (error) {
  //     console.log("error", error);
  //   }
  // }, [donor?.phone]);

  const handelCancel = async (id) => {
    if (!cancelComment.trim()) {
      notification("error", "Please provide a reason for cancellation.");
      return;
    }

    try {
      const sendData = {
        phone: donor?.phone,
        status: "inactive",
        id: id,
        cancel_reason: cancelComment
      };

      const response = await ApiService.updateAnnadaanSevaBookings(sendData);

      if (response?.status === 200 || response?.message) {
        notification("success", response.message || "Booking cancelled successfully!");
        closeDialogView();
        fetchBookings();
      } else {
        notification("error", "Failed to cancel booking.");
      }
    } catch (error) {
      notification("error", "Something went wrong!");
      console.error("Error in handelCancel:", error);
    }
  };

  const handleFeedbackSubmit = async () => {
    if (!feedbackText.trim()) {
      notification("error", "Please enter feedback before submitting.");
      return;
    }

    try {
      const sendData = {
        id: bookingid,
        feedback: feedbackText,
        inspiration,
        organization_clarity: clarity,
        challenges,
        challenge_details: challengeDetails,
        suggestions,
      };

      const response = await ApiService.submitAnnadaanSevaFeedback(sendData);

      if (response?.status === 200 || response?.message) {
        notification("success", response.message || "Feedback submitted successfully!");

        // ✅ Clear all fields
        setFeedbackText("");
        setInspiration([]);
        setClarity("");
        setChallenges("");
        setChallengeDetails("");
        setSuggestions("");

        closeFeedbackView();
        fetchBookings();
      } else {
        notification("error", "Failed to submit feedback.");
      }
    } catch (error) {
      notification("error", "Something went wrong!");
      console.error("Error in handleFeedbackSubmit:", error);
    }
  };


  useEffect(() => {
    fetchBookings();
  }, [fetchBookings]);

  return (
    <>
      <GoToTop />
      <MetaData title="Dashboard - ISKCON of Attapur" />

      <section className="dashboard-table">
        <div className="container">
          <div className="top-head pb-3 pb-lg-0 heading">
            <h2 className="head-1"></h2>
            <div className="d-flex justify-content-center flex-wrap">
              <DownloadTenbe />
              <button className="custom-btn-cls box-hover text-uppercase" onClick={() => navigate("/annadaanseva")}>
                Annadaan Seva
              </button>
              {/* <button className="custom-btn-cls box-hover text-uppercase" onClick={() => navigate("/annadaan-seva")}>
                Annadaan Seva Registration
              </button> */}
              <button className="custom-btn-cls box-hover text-uppercase" onClick={() => navigate("/service-requests")}>
                Service Requests
              </button>
              <button className="custom-btn-cls box-hover text-uppercase" onClick={() => navigate("/join-family")}>
                Join Family
              </button>
              <button className="custom-btn-cls box-hover text-uppercase" onClick={() => navigate("/all-transactions")}>
                All Transactions
              </button>
              <button className="custom-btn-cls box-hover" onClick={() => navigate("/donation-form")}>
                Donate more
              </button>
            </div>
          </div>

          <div className="mt-5">
            <h5 className="table-title mt-lg-5 mt-3 mb-lg-3 mb-0" style={{ textTransform: 'none' }}>
              Annadaan Seva Details <span className="text-muted">(Join us by booking your slot, <a href="/annadaan-seva">click here</a>)</span>
            </h5>


            <div className="table-heading py-lg-4 py-2 d-none d-lg-block">
              <div className="row justify-content-center align-items-center">
                <div className="col-lg-3 text-center">
                  <h5>Full Name</h5>
                </div>
                <div className="col-lg-3 text-center">
                  <h5>Person</h5>
                </div>
                <div className="col-lg-3 text-center">
                  <h5>Date</h5>
                </div>
                {/* <div className="col-lg-2 text-center">
                  <h5>Status</h5>
                </div> */}
                <div className="col-lg-3 text-center">
                  <h5>Action</h5>
                </div>
              </div>
            </div>

            <div className="table-content pt-2 pt-lg-0 mt-2">
              {Object.entries(bookingsData).map(([date, entries]) =>
                entries.map((data) => (
                  <div key={data.id} className="mb-3 border rounded p-3">
                    <div className="row text-center align-items-center">
                      <div className="col-6 col-lg-3 mb-2 mb-lg-0">
                        <strong className="d-lg-none">Full Name:</strong>
                        <div>{data?.name}</div>
                      </div>
                      <div className="col-6 col-lg-3 mb-2 mb-lg-0">
                        <strong className="d-lg-none">Person:</strong>
                        <div>{data?.participants}</div>
                      </div>
                      <div className="col-6 col-lg-3 mb-2 mb-lg-0">
                        <strong className="d-lg-none">Date:</strong>
                        <div>{moment(date).format("DD-MM-YYYY")}</div>
                      </div>
                      {/* <div className="col-6 col-lg-2 mb-2 mb-lg-0">
                        <strong className="d-lg-none">Status:</strong>
                        <div className={data.status === "active" ? "text-success" : data.status === "closed" ? "text-warning" : "text-danger"}>
                          {data.status === "active" ? "OPEN" : data.status === "closed" ? "CLOSED" : "CANCELLED"}
                        </div>
                      </div> */}
                      <div className="col-6 col-lg-3">
                        {data.status === "active" && (
                          <>
                            <button className="bg-danger badge  border rounded text-uppercase text-white" onClick={() => { setIsDialogOpen(true); setBookingid(data.id); }}>
                              Cancel
                            </button>
                            &nbsp;
                            <button className=" bg-warning badge  border rounded text-uppercase text-white" onClick={() => navigate(`/annadaan-seva/${data.id}`)}>
                              Reschedule
                            </button>
                          </>
                        )}
                        {data.status === "closed" && !data.feedback ? (
                          <button className="badge bg-light text-dark border rounded text-uppercase" onClick={() => { setIsFeedbackOpen(true); setBookingid(data.id); }}>
                            Feedback
                          </button>
                        ) : data.feedback ? (
                          <span className="badge border rounded text-success">Completed</span>
                        ) : data.status === "inactive" ? <span className="badge border rounded text-danger">Cancelled</span> : null}
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Cancel Modal */}
      <Modal centered show={isDialogOpen} onHide={closeDialogView}>
        <div className="modal-wrap text-center p-3" style={{ maxWidth: "600px", margin: "0 auto", width: "70%" }}>
          <p className="fs-5 fw-semibold text-dark mb-3">
            If you don’t mind sharing, please let us know your reason for cancellation. Your feedback is valuable to us.

          </p>
          <textarea
            className="form-control w-100"
            rows="4"
            placeholder="Please provide the reason for cancellation..."
            value={cancelComment}
            onChange={(e) => setCancelComment(e.target.value)}
            style={{ resize: 'none' }}
          ></textarea>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <button type="button" className="btn btn-secondary" onClick={closeDialogView}>
              Close
            </button>
            <button type="button" className="btn btn-danger" onClick={() => handelCancel(bookingid)}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>


      {/* Feedback Modal */}
      <Modal centered show={isFeedbackOpen} onHide={closeFeedbackView}>
        <div className="modal-wrap p-3" style={{ maxWidth: "600px", margin: "0 auto", width: "100%" }}>
          <h5 className="text-center mb-3">Submit Feedback</h5>

          {/* Inspiration */}
          <label className="form-label">What inspired you to join the Annadaan Seva?</label>
          {["Spiritual purpose", "Community service", "Word of mouth", "Other"].map((option) => (
            <div className="form-check" key={option}>
              <input
                className="form-check-input"
                type="checkbox"
                value={option}
                checked={inspiration.includes(option)}
                onChange={(e) => {
                  const value = e.target.value;
                  setInspiration((prev) =>
                    prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
                  );
                }}
              />
              <label className="form-check-label">{option}</label>
            </div>
          ))}

          {/* Organization clarity */}
          <div className="mt-3">
            <label className="form-label">Was the seva well-organized?</label>
            {["Yes", "Somewhat", "No"].map((opt) => (
              <div className="form-check" key={opt}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="clarity"
                  value={opt}
                  checked={clarity === opt}
                  onChange={() => setClarity(opt)}
                />
                <label className="form-check-label">{opt}</label>
              </div>
            ))}
          </div>

          {/* Challenges */}
          <div className="mt-3">
            <label className="form-label">Did you face any challenges?</label>
            {["No", "Yes"].map((opt) => (
              <div className="form-check" key={opt}>
                <input
                  className="form-check-input"
                  type="radio"
                  name="challenges"
                  value={opt}
                  checked={challenges === opt}
                  onChange={() => setChallenges(opt)}
                />
                <label className="form-check-label">
                  {opt} {opt === "Yes" ? "– Please specify:" : ""}
                </label>
              </div>
            ))}
            {challenges === "Yes" && (
              <input
                className="form-control mt-2"
                type="text"
                placeholder="Challenge details"
                value={challengeDetails}
                onChange={(e) => setChallengeDetails(e.target.value)}
              />
            )}
          </div>

          {/* Experience feedback */}
          <div className="mt-3">
            <label className="form-label">What did you enjoy most?</label>
            <textarea
              className="form-control"
              rows="3"
              placeholder="How was your experience?"
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
            ></textarea>
          </div>

          {/* Suggestions */}
          <div className="mt-3">
            <label className="form-label">Any suggestions to improve?</label>
            <textarea
              className="form-control"
              rows="2"
              placeholder="Your suggestions"
              value={suggestions}
              onChange={(e) => setSuggestions(e.target.value)}
            ></textarea>
          </div>

          {/* Submit / Close */}
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button className="btn btn-secondary" onClick={closeFeedbackView}>
              Close
            </button>
            <button className="btn btn-primary" onClick={handleFeedbackSubmit}>
              Submit
            </button>
          </div>
        </div>
      </Modal>


    </>
  );
};

export default AnnadaanSevaDashboard;
